import { render, staticRenderFns } from "./ckTextEditor.vue?vue&type=template&id=21a6a896&"
import script from "./ckTextEditor.vue?vue&type=script&lang=js&"
export * from "./ckTextEditor.vue?vue&type=script&lang=js&"
import style0 from "./ckTextEditor.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports